import React from 'react';
import { Button } from 'devextreme-react/button';
import './style.scss';

export default function Buttons() {

  return (
    <React.Fragment>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Contained</div>
            <div className="form-value">
              <Button
                width={120}
                text="Contained"
                type="normal"
                stylingMode="contained"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Outlined</div>
            <div className="form-value">
              <Button
                width={120}
                text="Outlined"
                type="normal"
                stylingMode="outlined"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Text</div>
            <div className="form-value">
              <Button
                width={120}
                text="Text"
                type="normal"
                stylingMode="text"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Icon</div>
            <div className="form-value">
              <Button
                width={120}
                icon="home"
                text="Icon"
                type="normal"
                stylingMode="outlined"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Only Icon</div>
            <div className="form-value">
              <Button
                icon="home"
                type="normal"
                stylingMode="outlined"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Rounded</div>
            <div className="form-value">
              <Button
                icon="home"
                type="normal"
                stylingMode="outlined"
                className="button-rounded"
              />&nbsp;&nbsp;
              <Button
                width={120}
                text="Outlined"
                type="normal"
                stylingMode="outlined"
                className="button-rounded"
              />
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Normal</div>
            <div className="form-value">
              <Button
                width={120}
                text="Contained"
                type="default"
                stylingMode="contained"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Outlined</div>
            <div className="form-value">
              <Button
                width={120}
                text="Outlined"
                type="default"
                stylingMode="outlined"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Text</div>
            <div className="form-value">
              <Button
                width={120}
                text="Text"
                type="default"
                stylingMode="text"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Icon</div>
            <div className="form-value">
              <Button
                width={120}
                icon="home"
                text="Icon"
                type="default"
                stylingMode="outlined"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Only Icon</div>
            <div className="form-value">
              <Button
                icon="home"
                type="default"
                stylingMode="outlined"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Rounded</div>
            <div className="form-value">
              <Button
                icon="home"
                type="default"
                stylingMode="outlined"
                className="button-rounded"
              />&nbsp;&nbsp;
              <Button
                width={120}
                text="Outlined"
                type="default"
                stylingMode="outlined"
                className="button-rounded"
              />
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Contained</div>
            <div className="form-value">
              <Button
                width={120}
                text="Contained"
                type="success"
                stylingMode="contained"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Outlined</div>
            <div className="form-value">
              <Button
                width={120}
                text="Outlined"
                type="success"
                stylingMode="outlined"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Text</div>
            <div className="form-value">
              <Button
                width={120}
                text="Text"
                type="success"
                stylingMode="text"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Icon</div>
            <div className="form-value">
              <Button
                width={120}
                icon="home"
                text="Icon"
                type="success"
                stylingMode="outlined"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Only Icon</div>
            <div className="form-value">
              <Button
                icon="home"
                type="success"
                stylingMode="outlined"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Rounded</div>
            <div className="form-value">
              <Button
                icon="home"
                type="success"
                stylingMode="outlined"
                className="button-rounded"
              />&nbsp;&nbsp;
              <Button
                width={120}
                text="Outlined"
                type="success"
                stylingMode="outlined"
                className="button-rounded"
              />
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Contained</div>
            <div className="form-value">
              <Button
                width={120}
                text="Contained"
                type="danger"
                stylingMode="contained"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Outlined</div>
            <div className="form-value">
              <Button
                width={120}
                text="Outlined"
                type="danger"
                stylingMode="outlined"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Text</div>
            <div className="form-value">
              <Button
                width={120}
                text="Text"
                type="danger"
                stylingMode="text"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Icon</div>
            <div className="form-value">
              <Button
                width={120}
                icon="home"
                text="Icon"
                type="danger"
                stylingMode="outlined"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Only Icon</div>
            <div className="form-value">
              <Button
                icon="home"
                type="danger"
                stylingMode="outlined"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Rounded</div>
            <div className="form-value">
              <Button
                icon="home"
                type="danger"
                stylingMode="outlined"
                className="button-rounded"
              />&nbsp;&nbsp;
              <Button
                width={120}
                text="Outlined"
                type="danger"
                stylingMode="outlined"
                className="button-rounded"
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
)}
